/**
 * Created by 唐亦慧 on 2018/2/6.
 */
import React from 'react';
import {Layout} from 'antd';
import {hashHistory,withRouter} from 'react-router';
import '../mallApp.css';
const {Header} = Layout;

class SubmitOrder extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			orderNum: '',
			orderId: '',
			status: 0
		}
		this.goView = this.goView.bind(this);
		this.routeLeaveHook = this.routeLeaveHook.bind(this);
	}
	
	componentDidMount() {
		var orderDetail = JSON.parse(window.localStorage.getItem('orderNum') || '{}');
		this.setState({
			orderNum: orderDetail.code || '',
			orderId: orderDetail.orderId || '',
			status: orderDetail.status || 0
		});
		this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
	}

    //离开当前路由时
	routeLeaveHook(nextLocation) {
		let path = nextLocation.pathname.split('/');
		if((path[1]==='mallCommon'&&path[2]==='productDetail')||path[1]==='mallCart') {
			hashHistory.push('/mallCommon/userCenter/order');
		}
	}
	
	//页面跳转
	goView(url) {
		hashHistory.push(url);
	}
	
	toggleHome() {
		let url = window.location.href;
		if (/dms-pc/.test(url)) {
			window.location.href = url.split('dms-pc')[0] + 'dms-pc/#/home';
		} else {
			window.location.href = '/#/home'
		}
	}
	
	render() {
		const {status, orderNum, orderId} = this.state;
		return <div>
			<Layout style={{background: '#fff'}}>
				<Header id='mall-cart'>
					{/*<div className="mall-logo">
						<a href="#" style={{cursor: 'default'}}>
							<h1>
								前海圆舟
							</h1>
						</a>
					</div>*/}
					{/*<div className="mall-go" onClick={this.toggleHome}>
						切换到卖家
					</div>*/}
					<div className="order-step">
						<div className='step-child'>
							<p>1</p>
							<p>1.我的购物车</p>
						</div>
						<div className='step-child'>
							<p>2</p>
							<p>2.填写核对订单信息</p>
						</div>
						<div className='step-child'>
							<p>3</p>
							<p>3.成功提交订单</p>
						</div>
					</div>
				</Header>
			</Layout>
			<div style={{padding: '0 50px 50px 50px', background: "#fff"}}>
				<div className="order-main">
					<div>
						<span>订单号：{orderNum}</span>
						<span>{status == 1 ? '已付款' : '待付款'}</span>
					</div>
					<p><i className="comIcon dmsFinish"></i></p>
					<p style={{fontSize: '16px', color: '#000'}}>订单提交成功，等待付款</p>
					<p>
						<span onClick={this.goView.bind(this, `/mallCommon/mallOrder/${orderId}`)}>查看订单</span>
						{
							status ?
								<span className='pay-already'>已支付</span>
								:
								<span className='no-pay' onClick={this.goView.bind(this, `/mallPay/goPay/${orderId}`)}>去支付</span>
						}
					</p>
				</div>
			</div>
		
		</div>
	}
}
;
export default withRouter(SubmitOrder);


// WEBPACK FOOTER //
// ./src/mall/mallPay/submitOrder.js